/**
 * @generated SignedSource<<56065f84f02f59da45589d42de536202>>
 * @relayHash 00432588237c35020eabadd88a19f1e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 389b5f223a40ee0ff7e763305001da55ecad5e2e73dacfaf2a80a389635ad5c5

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentStateInput = {
  color?: string | null;
  id?: AGG$Long | null;
  name?: string | null;
  spaceKey?: string | null;
};
export type EditorContentStateComponentSetContentStateAndPublishMutation$variables = {
  cloudId: string;
  contentId: string;
  contentStateInput: ContentStateInput;
  suppressDraftPropertyUpdate?: boolean | null;
};
export type EditorContentStateComponentSetContentStateAndPublishMutation$data = {
  readonly setContentStateAndPublish: {
    readonly color: string;
    readonly id: string | null;
    readonly name: string;
    readonly restrictionLevel: ContentStateRestrictionLevel;
  } | null;
};
export type EditorContentStateComponentSetContentStateAndPublishMutation = {
  response: EditorContentStateComponentSetContentStateAndPublishMutation$data;
  variables: EditorContentStateComponentSetContentStateAndPublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStateInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suppressDraftPropertyUpdate"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentState",
        "variableName": "contentStateInput"
      },
      {
        "kind": "Variable",
        "name": "suppressDraftPropertyUpdate",
        "variableName": "suppressDraftPropertyUpdate"
      }
    ],
    "concreteType": "ContentState",
    "kind": "LinkedField",
    "name": "setContentStateAndPublish",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "restrictionLevel"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "00432588237c35020eabadd88a19f1e9",
    "id": "389b5f223a40ee0ff7e763305001da55ecad5e2e73dacfaf2a80a389635ad5c5",
    "metadata": {},
    "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
    "operationKind": "mutation",
    "text": "mutation EditorContentStateComponentSetContentStateAndPublishMutation($contentId:ID!,$contentStateInput:ContentStateInput!,$suppressDraftPropertyUpdate:Boolean,$cloudId:ID!){setContentStateAndPublish(cloudId:$cloudId,contentId:$contentId,contentState:$contentStateInput,suppressDraftPropertyUpdate:$suppressDraftPropertyUpdate){name,color,id,restrictionLevel}}"
  }
};
})();

(node as any).hash = "ceadf0b25d9333173e88de88519cfc8d";

export default node;
